import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe41ced"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 1,
  class: "no-origin"
}

import { ref, onMounted, computed } from 'vue'

import { removeSchemaFromUrl } from '@/shared/utils'
import { PopupDatabase } from '@/popup/storage/Database'

type Props = {
  origin?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Origin',
  props: {
    origin: {}
  },
  setup(__props: any) {

const props = __props
const icon = ref<string | ArrayBuffer | null | undefined>('')
const origin = ref(removeSchemaFromUrl(props.origin || ''))

const originTruncated = computed(() => {
  const maxOriginLength = 20

  if (props.origin && origin.value.length > maxOriginLength) {
    return `${origin.value.slice(
      0,
      maxOriginLength / 2
    )}...${origin.value.slice(-(maxOriginLength / 2))}`
  }

  return origin.value
})

onMounted(async () => {
  if (!props.origin) {
    return
  }

  const dbOrigin = await PopupDatabase.getOrigin(props.origin)
  icon.value = dbOrigin?.icon
})

return (_ctx: any,_cache: any) => {
  return (origin.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "origin",
        title: origin.value
      }, [
        (icon.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "origin-icon",
              style: _normalizeStyle({
        backgroundImage: `url(${icon.value})`,
      }),
              role: "img"
            }, null, 4 /* STYLE */))
          : _createCommentVNode("v-if", true),
        _createTextVNode(" " + _toDisplayString(originTruncated.value), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2))
}
}

})